import { Card } from "antd";
import { useNavigate } from "react-router-dom";
import "./ClassCard.css";

const ClassCard = ({ classInfo }) => {
  const navigate = useNavigate();

  const viewClass = () => {
    navigate(`/classes/${classInfo.CourseId}`);
  };
  return <Card title={classInfo?.Name} onClick={() => viewClass()}></Card>;
};

export default ClassCard;
